import { API } from "../config/config";
import axios from "axios";

const FetchUserGroups = async (accessToken, uid) => {
    return new Promise((resolve, reject) => {
        if (Number.isNaN(uid)) { // check if uid is not numeric
            reject(new Error('Invalid Uid'));
        }

        return axios.post(API + '/usergroups', { uid: uid }, { withCredentials: true, headers: { Authorization: "Bearer " + accessToken } }).then((res) => {
            if (res.data) {
                resolve({ groups: res.data.groups, menu_items: res.data.menu_items, theme: res.data.theme });
            }
            reject(new Error('Invalid Result'));
        }).catch((err) => {
            reject(new Error('Invalid Result'));
        })
    })
}

export default FetchUserGroups;